import { BASE_URL } from '../constants';

export const openInNewTab = (url: string) => {
  const win = typeof window !== 'undefined' && window;
  if (win) {
    const newWin = win.open(`${BASE_URL}${url}`, '_blank', 'noopener, noreferrer');
    if (newWin) newWin.opener = null;
  }
};
